import FormatService from '../services/FormatService.js';

function getRandomRgb() {
  var num = Math.round(0xffffff * Math.random());
  var r = num >> 16;
  var g = (num >> 8) & 255;
  var b = num & 255;
  return `rgb(${r},${g},${b},1)`;
}

/**
 * we want our colors to be the same when the wall state will be updated
 * so we have to store the default colors array.
 *
 * Proxy will allow us to use the object as an array, with an unlimited index
 */
const defaultColorsArrayHandler = {
  colors: Array(100)
    .fill(0)
    .map(getRandomRgb),
  get(_target, name) {
    if (Number(name) < this.colors.length) {
      return this.colors[name];
    }
    return getRandomRgb();
  }
};
const defaultColorsArray = new Proxy({}, defaultColorsArrayHandler);

export const CommonMixin = {
  props: {
    answers: Array,
    question: Object,
    stats: Object,
    poll: Object
  },

  computed: {
    statsPercent() {
      return voteCount => {
        return FormatService.getPercent(voteCount, this.stats.totalVoteCount) || 0;
      };
    },

    invertColor() {
      return color => {
        return FormatService.invertColor(color);
      };
    },

    fontSize() {
      return text => {
        return FormatService.fontSize(text);
      };
    },

    atLeastOneImage() {
      return this.answers.some(answer => answer.image);
    }
  },

  methods: {
    getAnswerColor(poll, answerIndex) {
      const answerColors = poll.jsStyle.answerColors;
      return answerColors
        ? answerColors[answerIndex % answerColors.length]
        : defaultColorsArray[answerIndex];
    },

    getAnswerFromStat(statAnswer) {
      return this.answers.find(answer => answer.answerId === statAnswer.answerId);
    },

    answerPercent(answer) {
      const statAnswer = this.stats.answers.find(a => a.answerId === answer.answerId) || {};
      return FormatService.getPercent(statAnswer.voteCount, this.stats.totalVoteCount);
    }
  }
};

export default CommonMixin;
